import React, { Fragment } from 'react'
import { Icon } from './icon';
import { Text } from './text';
import "./list.css"

/**
 * List
 */
export const List = (props) => {

    const { items = [], children, onSelect, groupBy } = props

    function select(id) {
        if (onSelect) onSelect(id)
    }

    return groupBy ? <GroupedList {...props} onSelect={select} /> : (
        <div className="list">
            <ul>
                {items.map(item => <ListItem key={item.id} item={item} onSelect={select} />)}
            </ul>
            {children}
        </div>
    )
}

/**
 * Grouped List
 */
const GroupedList = (props) => {
    const { items = [], children, onSelect, groupBy } = props

    const groups = items.reduce((groups, item) => {
        let group = groups.find(g => g.name === item[groupBy])
        if (!group) {
            group = { name: item[groupBy], items: []}
            groups.push(group)
        } 
        group.items.push(item)
        return groups
    }, [])

    return (
        <div className="list">
            {groups.map(group => (
                <Fragment key={group.name}>
                    <header key={`${group.name}-header`}><Text>{group.name}</Text></header>
                    <ul key={`${group.name}-ul`}>
                        {group.items.map(item => <ListItem key={item.id} item={item} onSelect={onSelect} />)}
                    </ul>
                </Fragment>
            ))}
            {children}
        </div>
    )
}

/**
 * List Item
 */
const ListItem = ({ item, onSelect }) => {
    const { id, icon, line1, line2, meta } = item

    function select() {
        if (onSelect) onSelect(id)
    }

    return (
        <li onClick={select}>
            {icon ? <Icon icon={icon} size="small" /> : null}
            <main>
                <div className="primary-line"><Text>{line1}</Text></div>
                {line2 ? <div className="secondary-line"><Text>{line2}</Text></div> : null}
            </main>
            {meta ? <div className="meta">{meta}</div> : null}
        </li>
    )
}